<template>
  <div class="achievement-comparison">
    <achievementComparisonTopBar
      :examInfoList="examInfoList"
      @chartDialogShow="chartDialogClick"
      @derivedScore="derivedScore"
    />
    <achievementComparisonTable
      ref="comparisonTable"
      :studentList="studentList"
      :courseList="courseList"
    />
    <barChartDialog
      v-show="chartDialogShow"
      :chartDialogShow.sync="chartDialogShow"
      :studentList="barChartData"
      :examInfoList="examInfoList"
    />
    <!-- 分页 -->
    <!-- <div class="pagination">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageSize)"
        @currentPageNumChange="currentPageNumChange"
      />
    </div> -->
  </div>
</template>

<script>
import achievementComparisonTopBar from "./components/achievement-comparison-topBar/achievementComparisonTopBar.vue";
import achievementComparisonTable from "./components/achievement-comparison-table/achievementComparisonTable.vue";
import barChartDialog from "./components/bar-chart-dialog/barChartDialog.vue";
import pagination from "@/components/pagination/pagination";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  components: {
    achievementComparisonTopBar,
    achievementComparisonTable,
    barChartDialog,
    pagination,
  },
  data() {
    return {
      chartDialogShow: false,
      // 分页参数
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      studentList: [],
      courseList: [],
      examInfoList: [],
      barChartData: [],
    };
  },
  created() {
    this.studentList = this.$route.query.studentList;
    this.examInfoList = this.$route.query.comparativeExamData;
    if (!this.studentList.length) return this.$message.warning("暂无数据");

    // console.log("this.studentList:", this.studentList, this.studentList[0][0]);

    // courseList-table遍历多科目成绩时用到
    this.studentList[0][0].examInfoScoreList.forEach((item) => {
      item.courseScoreList.forEach((aItem) => {
        if (!this.courseList.includes(aItem.courseName)) {
          this.courseList.push(aItem.courseName);
        }
      });
    });
  },
  methods: {
    // 导出
    derivedScore() {
      let examInfoIds = this.examInfoList.map((item) => item.id);
      let studentIds = this.studentList[0].map((item) => item.studentId);
      let action = `${baseURL}${this.$url.moreStudentAvgScoreRankContrastExcelPC}?examInfoIds=${examInfoIds}&studentIds=${studentIds}`;
      window.open(action);
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
    },
    chartDialogClick(e) {
      this.barChartData =
        this.studentList[+this.$refs.comparisonTable.examName];
      // console.log("this.barChartData:", this.barChartData);
      this.chartDialogShow = e;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementComparison.scss";
</style>